import React from 'react';

import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { API_BASE } from "../api/apiConfig";

const Index = () => {
  return (
    <>
      <Header />


<main className="flex-1">
  {/*$*/}
  {/*$*/}
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
    <div className="text-center px-4">
      <div className="mb-8">
        <h1 className="text-9xl font-bold text-gray-300">404</h1>
      </div>
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">
          Oops! Page Not Found
        </h2>
        <p className="text-gray-600 text-lg max-w-md mx-auto">
          The page you're looking for doesn't exist. It might have been moved,
          deleted, or you entered the wrong URL.
        </p>
      </div>
      <div className="space-y-4">
        <a
          className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-11 rounded-md px-8"
          href="/"
        >
          Go Back Home
        </a>
        <div className="text-sm text-gray-500">
          <a className="hover:text-blue-600 underline" href="/grouptrips">
            Browse Destinations
          </a>{" "}
          •{" "}
          <a className="hover:text-blue-600 underline" href="/experts">
            Find Experts
          </a>{" "}
          •{" "}
          <a className="hover:text-blue-600 underline" href="/community">
            Join Community
          </a>
        </div>
      </div>
    </div>
  </div>
  {/*/$*/}
  {/*/$*/}
</main>



      <Footer />
    </>
  );
};

export default Index;
